module.exports = __webpack_public_path__ + "static/media/5DPO7.735244a6.jpg";